class DoNothingTreeNode {
  // A private member makes the class nominal, so instanceof narrowing does not match every object type.
  private readonly isDoNothing = true;
}

export default DoNothingTreeNode;
